import { useQuery } from '@apollo/client';
import { VerifiedUser } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { AuditLogList } from '~/components/AuditLogs';
import { RouterBreadcrumbs } from '~/components/RouterBreadcrumbs';
import { ScrollableRouterTabs } from '~/components/RouterTabs';
import { PageContainer } from '~/components/page-layout';
import { Toolbar } from '~/components/toolbar';
import { useAppContext } from '~/contexts';
import { useLink } from '~/hooks/link';
import { useTabs } from '../lib/tabs';
import { NetworkRoleAuditLogsDocument } from './RoleAuditLogs.generated';

export const RoleAuditLogs = () => {
  const { t } = useTranslation();
  const params = useParams<{ roleId: string }>();
  const roleId = parseInt(params.roleId ?? '');

  const { currentNetwork } = useAppContext();
  const link = useLink();
  const tabs = useTabs();

  const { data, loading } = useQuery(NetworkRoleAuditLogsDocument, {
    variables: { networkId: currentNetwork.id, roleId },
  });

  const role = data?.network?.role;

  if (loading || !role) return !loading ? <Navigate to={link('/not-found')} replace /> : null;

  return (
    <>
      <Toolbar
        breadcrumbsLabel={<RouterBreadcrumbs />}
        titleIcon={<VerifiedUser />}
        titleText={role.name}
      />

      <ScrollableRouterTabs current={t('common.tabs.audit_logs')} tabs={tabs} />

      <PageContainer>
        <AuditLogList recordTypes={['Role']} roleId={roleId} />
      </PageContainer>
    </>
  );
};
